export default __webpack_public_path__ + "static/media/j0l0zm9f.a4a5c41e.png";